export const isFacetEnabledSelector = (state, id) => {
    return state.facetOptions.facets[id]?.enabled ?? true;
};
export const selectFacetOptions = (state) => {
    const { freezeFacetOrder } = state.facetOptions ?? {};
    return freezeFacetOrder !== undefined ? { freezeFacetOrder } : undefined;
};
